module.exports = "/assets/88abf34a4a75d58c701439893afa55bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AE.png
// module id = 1192
// module chunks = 0